export const strings = {
  views: 'Görünümler',
  share: 'Paylaşmak',
  share_count: 'Paylaşımlar',
  edit: 'Düzenlemek',
  title: 'Haberler',
  news: 'Haberler',
  similar_news: 'Benzer Haberler',
  add_news: 'Haber Ekle',
  publish: 'Yayımlandı',
  published: 'Yayımla',
  cover_image: 'Kapak Resmi',
  news_title: 'Haber Başlığı',
  brief: 'Kısa bilgi',
  tags: 'Etiketler (İlgili arama sonuçlarını göstermemize yardımcı olmak için etiketler ekleyin)',
  url: 'Kaynak',
  optional: 'İsteğe bağlı',
  summary: 'Özet',
  title_placeholder: 'Başlığı girin',
  brief_placeholder: 'Buraya yaz...',
  tags_placeholder: 'Etiket ekle',
  url_placeholder: 'URL bağlantısını buraya yapıştırın',
  time_taken: 'Okumak İçin Geçen Süre (İsteğe Bağlı)',
  time_placeholder: 'Dakika olarak süreyi girin',
  speciality: 'Uzmanlık',
  add_tag: 'Etiket Ekle',
  no_news: 'Haber Yok',
  mentions: 'Bahsedilenler',
  add_mention: 'Bahsetme Ekle',
  no_news_message: 'Haber Bulunamadı.',
  errors: {
    cover_required: 'Kapak resmini yüklemeniz gerekiyor',
    title_required: 'Haber Başlığı gereklidir',
    url_required: 'Haber URL\'si gerekli',
    country_required: 'Ülke gerekli',
    title_min_length: 'Haber başlığı en az 3 karakter olmalıdır',
    title_max_length: 'Haber başlığı 250 karakterden uzun olamaz',
    brief_required: 'Haber Özeti gereklidir',
    brief_min_length: 'Haber Özeti en az 3 karakter olmalıdır',
    brief_max_length: 'Haber Özeti 250 karakterden uzun olamaz',
    duration_number: 'Zaman her zaman bir sayı olmalıdır',
    duration_min: 'Zaman sıfırdan büyük olmalıdır',
    duration_max: 'Zaman 1000\'den büyük olmamalıdır',
    url: 'Kaynak geçerli bir URL olmalıdır',
    url_max_limit: 'Kaynak 300 karakterden uzun olamaz',
    description_required: 'Haber açıklaması gereklidir',
    description_min_length: 'Haber açıklaması en az 3 karakter olmalıdır',
    description_max_length: 'Haber açıklaması 2500 karakterden uzun olamaz',
    speciality_id_required: 'Lütfen bir uzmanlık alanı seçin',
    cover_uploading: 'Kapak yükleniyor',
  },
  published_ago: 'Yayımlandı {date}',
  submitted_ago: 'Gönderildi {date}',
  edit_news: 'Haberleri Düzenle',
  delete_draft: 'Taslağı Sil',
  source: 'Kaynak',
  discard_changes: 'Değişiklikleri Sil',
  delete_news: 'Haberleri Sil',
  saving_changes_confirmation: 'Değişiklikleri kaydetmeden geri dönmek istediğinizden emin misiniz?',
  saving_changes_confirmation_desc: 'Kaydedilmemiş değişiklikleriniz var. Son yaptığınız tüm değişiklikleri kaybedeceksiniz ve bu işlem geri alınamaz.',
  cancel: 'İptal etmek',
  share_news: 'Haberleri Paylaş',
  regional_case: 'Bölgesel Vaka1',
  published_two_years_ago: '2 yıl önce yayınlandı',
  save_news_confirm: 'Değişiklikleri kaydetmeden geri dönmek istediğinizden emin misiniz?',
  save_news_confirm_para: 'Kaydedilmemiş değişiklikleriniz var. Son yaptığınız tüm değişiklikleri kaybedeceksiniz ve bu işlem geri alınamaz.',
  delete_news_confirm: 'Bu haberi silmek istediğinize emin misiniz?',
  delete_news_confirm_para: 'Bu haberi silmek istediğinizden eminseniz sil butonuna tıklayın. Bu eylem geri alınamaz.',
};